module.exports = __webpack_public_path__ + "static/media/payroll-real-time.e958252c.png";